import { ModalAction, ModalComponent } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text, StyleSheet, TextInput, TouchableOpacity, NativeSyntheticEvent, TextInputKeyPressEventData } from 'react-native'

type EmailOTPVerificationPopupProps = {
  headerTitle: string
  contentTitle: string
  verificationEmail: string
  isVisible: boolean
  inputedOTPDataArr: string[]
  setInputedOTPDataArr: (data: string[]) => void
  OTPErrorMsg?: string
  isVerifiedEmailOTP?: boolean
  otpTimer?: string
  OTPVerifiedSuccessMsg?: string
  onCloseModal: () => void
  onCancelEvent?: () => void
  onYesEvent?: () => void
  onResendEvent?: () => void
}
export const EmailOTPVerificationPopup = (props: EmailOTPVerificationPopupProps) => {
  const {
    headerTitle,
    isVisible,
    onCloseModal,
    onCancelEvent,
    onYesEvent,
    contentTitle,
    verificationEmail,
    inputedOTPDataArr,
    setInputedOTPDataArr,
    isVerifiedEmailOTP,
    OTPErrorMsg,
    otpTimer,
    onResendEvent,
    OTPVerifiedSuccessMsg
  } = props
  const { t } = useTranslation()
  const inputsRef = React.useRef<TextInput[]>([])
  const actions: ModalAction[] = [
    {
      text: t('requestInfo:Continue'),
      type: 'filled',
      action: () => onCloseModal && onCloseModal(),
      disabled: isVerifiedEmailOTP == false,
      loading: false,
      onlyWide: false,
      style: modalStyles.btnLine
    },
    {
      text: t('common:Cancel'),
      type: 'outline',
      action: () => onCancelEvent && onCancelEvent(),
      disabled: false,
      loading: false,
      onlyWide: false,
      style: {}
    }
  ]

  const isEnabledResendAction = React.useMemo(() => {
    return otpTimer === '00:00' ? true : false
  }, [otpTimer])

  const handleChangeText = (text: string, index: number) => {
    const customedText = text.replace(/[^0-9]/g, '')
    let customedInputedDataArr: string[] = [...inputedOTPDataArr]
    customedInputedDataArr[index] = text
    setInputedOTPDataArr(customedInputedDataArr)
    if (customedText && index < inputedOTPDataArr.length - 1) {
      inputsRef.current[index + 1].focus()
    }

  }

  const handleKeyPress = (e: NativeSyntheticEvent<TextInputKeyPressEventData>, index: number) => {
    const OTPNumber = inputedOTPDataArr[index]
    if (e.nativeEvent.key === 'Backspace' && !OTPNumber && index > 0) {
      inputsRef.current[index - 1].focus()
    }
  }

  return (
    <ModalComponent
      title={headerTitle}
      visible={isVisible}
      onClose={onCloseModal}
      centerTitle={true}
      actions={actions}
      modalWidth={400}
      contentStyle={modalStyles.modalContainer}
      modalContainerStyle={modalStyles.modalContainer}
      headerContainerStyle={modalStyles.headerContainer}
      buttonGroupStyle={modalStyles.buttonGroup}
    >
      <View style={modalStyles.modalBodyContainer}>
        <View style={modalStyles.bodyHeaderContent}>
          <Text style={modalStyles.headerContentText}>{contentTitle}</Text>
          <Text style={[modalStyles.hightLightText, modalStyles.headerContentText]}>{verificationEmail}</Text>
        </View>
        <View style={modalStyles.OTPContainer}>
          {inputedOTPDataArr.length > 0 && inputedOTPDataArr.map((OTPBoxVal: string, index: number) => (
            <View style={modalStyles.OTPContent} key={`BoxView_${index}`}>
              <TextInput
                key={`TextInput_${index}`}
                ref={(refVal) => inputsRef.current[index] = refVal!}
                value={OTPBoxVal}
                onChangeText={(val) => {
                  // const customedText = val.replace(/[^0-9]/g, '')
                  handleChangeText(val, index)
                }}
                maxLength={1}
                autoFocus={index === 0}
                onKeyPress={(e) => handleKeyPress(e, index)}
                style={modalStyles.OTPInputContent}
              />
            </View>
          ))}
        </View>
        {OTPErrorMsg && (
          <View style={modalStyles.OTPErrorContent}>
            <Text style={modalStyles.hightLightText}>{OTPErrorMsg}</Text>
          </View>
        )}
        {OTPVerifiedSuccessMsg && (
          <View style={modalStyles.OTPErrorContent}>
            <Text style={modalStyles.successfullMessageText}>{OTPVerifiedSuccessMsg}</Text>
          </View>
        )}
        <View style={modalStyles.OTPErrorContent}>
          <TouchableOpacity disabled={!isEnabledResendAction} onPress={onResendEvent}>
            <View>
              <Text style={isEnabledResendAction ? modalStyles.OTPResendHightlightText : modalStyles.OTPResendDisabledText}>{`${t('OTP:resend')} (${otpTimer})`}</Text>
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </ModalComponent>
  )
}
const modalStyles = StyleSheet.create({
  modalContainer: {
    backgroundColor: '#f2f2f2'
  },
  headerContainer: { marginVertical: 10, marginHorizontal: 10 },
  modalBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  bodyHeaderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 20
  },
  hightLightText: {
    color: '#ed1b2c'
  },
  headerContentText: { fontWeight: '700' },
  OTPContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  OTPContent: {
    width: 40,
    height: 50,
    marginHorizontal: 5,
    borderRadius: 10,
    backgroundColor: '#FFF',
    boxShadow: '0px 12px 36px 0px rgba(243, 235, 235, 1)'
  },
  OTPInputContent: {
    width: '100%',
    height: '100%',
    fontSize: 24,
    lineHeight: 20,
    textAlign: 'center'
  },
  OTPErrorContent: {
    marginVertical: 10
  },
  OTPResendContainer: {

  },
  OTPResendHightlightText: {
    color: 'blue',
    cursor: 'pointer',
    textDecorationLine: 'underline'
  },
  OTPResendDisabledText: {
    color: '#B0B0B0',
  },
  btnLine: {
    marginRight: 15
  },
  buttonGroup: {
    marginTop: 15,
    marginBottom: 15
  },
  successfullMessageText: {
    color: 'green'
  },
})